// extracted by mini-css-extract-plugin
module.exports = {"paymentMethodList":"T6L49","modalTheme":"_2HwAX","noMargin":"xcEfk","wrapper":"_1M-QB","paymentComponent":"_1aDbK"};